import axios from 'axios'
import { logger } from '../main'

let mockingEnabled = process.env.VUE_APP_MOCK_ENABLED || false

const mocks = {}

export function addMock(url, data) {
    mocks[url] = data
}

export function addMocks(arr) {

    for(let i=0;i<arr.length;i++) {
        mocks[arr[i]['url']] = arr[i]['data'];
    }
}

export function enableMocking(state) {
    mockingEnabled = state
}

const isUrlMocked = url => {
    for (const mockItem in mocks) {
        if (url.endsWith(mockItem)) {
            return true
        }
    }
}

const getMockedDataByUrl = url => {
    for (const mockItem in mocks) {
        if (url.endsWith(mockItem)) {
            return mocks[mockItem]
        }
    }
}

const getMockError = config => {
    const mockError = new Error()

    // @ts-ignore
    mockError.mockData = getMockedDataByUrl(config.url)

    // @ts-ignore
    mockError.config = config

    return Promise.reject(mockError)
}

const isMockError = error => Boolean(error.mockData)

const getMockResponse = mockError => {
    const {mockData, config} = mockError
    // Handle mocked error (any non-2xx status code)
    if (mockData.status && String(mockData.status)[0] !== '2') {
        const err = new Error(mockData.message || 'mock error')
        // @ts-ignore
        err.code = mockData.status
        return Promise.reject(err)
    }

    const response = Object.assign({
        status: mockData.status || 200,
        config,
        isMock: true
    }, mockData);

    logger.warn('[api]', 'mock:' + config.url, 'response:', response)

    // Handle mocked success
    return Promise.resolve(mockData)
}

// Add a request interceptor
axios.interceptors.request.use(config => {
    if (mockingEnabled && isUrlMocked(config.url)) {
        logger.debug('[api]','url:',config.url,'payload:',config.data)
        return getMockError(config)
    }
    return config
}, error => Promise.reject(error))

// Add a response interceptor
axios.interceptors.response.use(response => response, error => {
    if (isMockError(error)) {
        return getMockResponse(error)
    }
    return Promise.reject(error)
})